import axios from "axios";
import API from "../../common/API";
import { API_URL } from "../../config/config";

/*** 
  @purpose : Get territory definition list
  @Parameter : {}
  **/
  export const getMarketAuthList = async (body) => {
    const token = sessionStorage.getItem("token");
    const wwid= sessionStorage.getItem("WWID")
    let timestamp = new Date().getTime()
    return await axios.get(API_URL + API.MARKET_AUTH_LIST + `?wwid=${wwid}&timestamp=${timestamp}`,
    { headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*', "timestamp": timestamp}}
    )
      .then((response) => {
        if (response.data.success == true) {
          return response.data;
        }
      });
  };

export const fetchMRList = async (body) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime()
    return fetch(API_URL + API.GET_ALLOCATED_MR_LIST, {
      method: "post",
      headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*', "timestamp": timestamp, mode: 'no-cors'},
      body: JSON.stringify(body),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        return data.data;
      });
};

export const getChildFacilityList = async (body) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime()
  return fetch(API_URL + API.PARENT_CHILD_FACILITY_LIST, {
    method: "post",
    headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*', "timestamp": timestamp, mode: 'no-cors'},
    body: JSON.stringify(body),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      return data;
    });
};

export const getConfigurableParentFacilityList = async (body) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime()
  return fetch(API_URL + API.GET_CONFIGURABLE_PARENT_FACILITY_LIST, {
    method: "post",
    headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*', "timestamp": timestamp, mode: 'no-cors'},
    body: JSON.stringify(body),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      return data;
    });
};

export const getParentFacilityList = async (body) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime()
  return fetch(API_URL + API.GET_PARENT_FACILITY_LIST, {
    method: "post",
    headers: { 'x-api-key': token, 'Access-Control-Allow-Origin': '*', "timestamp": timestamp, mode: 'no-cors'},
    body: JSON.stringify(body),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      return data;
    });
};

export const saveParentChildFacilityChange = async (body) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime()
  const wwid = sessionStorage.getItem("WWID");
  return fetch(API_URL + API.SAVE_PARENT_CHILD_FACILITY_CHANGE, {
    method: "post",
    headers: { 'x-api-key': token, 'wwid': wwid, 'Access-Control-Allow-Origin': '*', "timestamp": timestamp, mode: 'no-cors'},
    body: JSON.stringify(body),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      return data;
    });
};